import { TSaveP5FReq } from "@sharedTypes/req.type";
import { TSaveP5FRes } from "@sharedTypes/res.type";

import missingParametersError from "api/Error";
import axios from "axios";

export async function SaveP5F(saveName: string, userUpdateValues: any) {
  const apiUrl = "/tools/p5f/savep5f";

  const body: TSaveP5FReq = {
    saveName,
    forcesData: userUpdateValues,
  };

  for (const [key, param] of Object.entries(body)) {
    if (param === undefined) throw missingParametersError(key);
  }

  const data: TSaveP5FRes = await axios
    .post(apiUrl, body)
    .then((res) => res.data)
    .catch((err) => {
      console.log(err);
      throw err.response.data;
    });
  return data;
}
